export const POPUP = {
  CONSULT_WITH_US: 'consult_with_us',
  CONNECT_WITH_ONCOLOGIST: 'connect_with_oncologist',
  SHARE_WITH_MY_DOCTOR: 'share_with_my_doctor',
  HCP_SHARE_WITH_DOCTOR: 'hcp_share_with_my_doctor',
  SEND_TO_DOCTOR: 'send_to_doctor',
  ADD_DOCTOR: 'add_doctor',
  SEARCH_DOCTOR: 'search_doctor',
  NEXT_SCAN: 'next_scan',
  CHANGE_LOCATION: 'change_location',
  USER_INTENT: 'user_intent',
  EDIT_QUESTION: 'edit_question',
  MEDICAL_PROFILE: 'medical_profile',
  QUESTIONNAIRE: 'questionnaire',
  QUESTIONS: 'questions',
  HAS_ANYTHING_CHANGED: 'has_anything_changed',
  NEXT_APPOINTMENT: 'next_appointment',
  TREATMENT_SURVEY: 'treatment_survey',
  TRAVELING_PREFERENCES: 'traveling_preferences',
  SEE_ALL_OPTIONS: 'see_all_options',
  MISSING_CRITICAL_INFORMATION: 'missing_critical_information',
  DEBUG: 'debug',
  GENERAL: 'general',
  CONTACT_US: 'contact_us',
  PREFERENCE_CATEGORY: 'preference_category',
  BIOMARKERS: 'biomarkers',
  PHONE_NUMBER: 'phone_number',
  CALLUS: 'call_us',
  UNSUBSCRIBE_FORM: 'unsubscribe_form',
  INTAKE: 'intake',
  ABOUT_YOU: 'about_you',
  CHAT_UPLOAD: 'chat_upload',
  CHAT_UPLOAD_EXPLAIN: 'chat_upload_explain',
  ASSISTANCE_CHAT: 'assistance_chat',
  NBA_CHAT: 'nba_chat',
  UPLOAD: 'upload',
  CURRENT_USER_UPLOAD: 'current_user_upload',
  ADD_HCP_PATIENT: 'add_hcp_patient',
  USER_SIGNUP: 'user_signup',
  HCP_USER_SIGNUP: 'hcp_user_signup',
  HCP_PATIENT_SIGNUP: 'hcp_patient_signup',
  AI_ASSISTANT: 'ai_assistant',
  PHONE_IS_ALREADY_USED: 'phone_is_already_used',
  GET_IN_TOUCH: 'get_in_touch',
  INTAKE_ONBOARDING: 'intake_onboarding',
};

export const POPUPS = Object.values(POPUP);
